import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  getProcessJournalListQuery,
  getPlannerElementEvidencesQuery,
} from "./Queries";
import { processJournalFragment } from "./Fragments";

export const getProcessJournalListFromCache = params => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getProcessJournalListQuery,
      variables: params,
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getPlannerElementEvidencesFromCache = params => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getPlannerElementEvidencesQuery,
      variables: params,
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const writeProcessJournalListInCache = ({ data, variables }) => {
  try {
    client.writeQuery({
      query: getProcessJournalListQuery,
      variables,
      data,
    });
  } catch (e) {
    console.error(e);
    return {};
  }
};

export const writeProcessJournalInCache = ({ id, data }) => {
  try {
    client.writeFragment({
      id: `Post:${id}`,
      fragment: processJournalFragment.basicDetails,
      fragmentName: "processJournalItem",
      data,
    });
  } catch (e) {
    console.error(e);
  }
};

export const readProcessJournalFromCache = params => {
  let queryData = {};

  try {
    queryData = client.readFragment({
      id: `Post:${params.id}`,
      fragment: processJournalFragment.basicDetails,
      fragmentName: "processJournalItem",
    });
  } catch (e) {
    console.warn(e);
    return {};
  }

  if (queryData != null) return queryData;
  else return {};
};
